<script>
	import { uiText } from "../lib/uiText.js";
	import { createEventDispatcher, onMount } from "svelte";
	// import Play from './Play.svelte';
	// import Sortable from 'sortablejs/modular/sortable.complete.esm.js';

	const dispatch = createEventDispatcher();
	export let lang = "en";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));
	// export let pastAnswers = [];
	export let riddle;
	// console.log(riddle);
	// let progbar = riddle.progbar;
	let type = riddle.type || "single";
	let answers = riddle.answers;
	let isBonus = false;
	let input = "";
	let order = [];
	let wrongAnswers = [];

	// $: order, order;
	// const inActive = [];
	// const inPast = [];

	function handleButton(data) {
		if (type == "btn-to-input") {
			input = input + data;
		} else {
			order.push(data);
			order = order;
			input = order.join("-");
			// console.log(input);
		}
	}

	//
	function checkAnswer() {
		if (input == "" || input.replace(/\s/g, "") == "") {
			console.warn("don't try empty answers, man!");
			return;
		}
		if (answers.some((el) => input.toLowerCase().includes(el))) {
			dispatch("message", {
				msg_content: ui.game.riddle.single_message,
				msg_type: "info",
				msg_action: ui.game.riddle.single_action,
			});
			if (riddle.isBonus) {
				isBonus = true;
			} else {
				isBonus = false;
			}
			dispatch("solve", {
				address: riddle.address,
				wrongAnswers: wrongAnswers,
				isBonus: isBonus,
			});
		} else {
			dispatch("message", {
				msg_content: ui.game.riddle.wrong_message,
				msg_type: "error",
				msg_action: ui.game.riddle.wrong_action,
			});
			wrongAnswers.push(input);
		}
	}

	const handleEnter = (e) => {
		if (e.key === "Enter" || e.keyCode === 13) {
			checkAnswer();
		}
	};
</script>

<ul
	id="panel"
	class=" place-self-center"
	style={riddle.panel_type == "grid"
		? "display:grid; grid-template-rows: repeat(" +
			riddle.panel_size.rows +
			", max-content); grid-template-columns:repeat(" +
			riddle.panel_size.cols +
			", max-content);"
		: riddle.panel_type == "horizontal"
			? "display:flex;  flex-direction:row"
			: "display:flex; flex-direction:column"}
>
	{#each riddle.panel_list as item, i}
		<li
			data-id={riddle.panel_id_list ? riddle.panel_id_list[i] || i : i}
			on:click={() =>
				handleButton(riddle.panel_id_list ? riddle.panel_id_list[i] || i : i)}
		>
			{@html item}
		</li>
	{/each}
</ul>

{#if type == "btn-order" || type == "btn-order-hidden"}
	<ul id="thumbnails" class="flex flex-wrap gap-3 place-self-center">
		{#each order as item, i}
			<li>
				{#if type == "btn-order"}
					{@html riddle.panel_thumbnail_list
						? riddle.panel_thumbnail_list[item] || item
						: item}
				{:else}
					·
				{/if}
				<!-- {@html riddle.panel_thumbnail_list[item]} -->
				<!-- {item} -->
			</li>
		{/each}
	</ul>
{/if}

<div
	class={type == "btn-order" || type == "btn-order-hidden"
		? "input-btn-order"
		: "input-row"}
>
	{#if type !== "btn-order" && type !== "btn-order-hidden"}
		<input
			class="grow"
			type="text"
			name="field"
			id="field"
			placeholder="_"
			bind:value={input}
			on:keyup={handleEnter}
		/>
	{:else}
		<button
			class="justify-center place-self-center outline"
			on:click={() => (order = [])}
		>
			<i class="fa-solid fa-arrows-rotate" data-position="left" />{ui.game.aside
				.button_reset}
		</button>

		<button
			class="justify-center place-self-center outline"
			disabled={order.length ? false : true}
			on:click={() => {
				order.pop();
				order = order;
			}}
		>
			<i class="fa-solid fa-delete-left" data-position="left" />{ui.game.aside
				.button_backspace}
		</button>
	{/if}

	<button id="trigger" on:click={checkAnswer}
		>{type !== "btn-order" && type !== "btn-order-hidden"
			? ui.game.aside.button
			: ui.game.aside.button_check}</button
	>
</div>

<style>
	.input-row {
		display: grid;
		grid-template-columns: 1fr max-content;
	}
	.input-btn-order {
		display: flex;
		flex-wrap: wrap;
		place-content: center;
		place-self: center;
	}
	@media screen and (max-width: 480px) {
		.input-row {
			grid-template-columns: auto;
		}
	}
</style>
